import type { AdminSession, CaptchaChallenge, LoginRequest } from '@mall/shared';
import { apiClient } from '../../app/api';

export async function login(payload: LoginRequest): Promise<AdminSession> {
  return apiClient.post<AdminSession>('/admin/auth/login', payload);
}

export async function logout(): Promise<void> {
  await apiClient.post<void>('/admin/auth/logout');
}

export async function fetchMe(): Promise<AdminSession | null> {
  return apiClient.get<AdminSession | null>('/admin/auth/me');
}

export async function fetchCaptcha(): Promise<CaptchaChallenge> {
  return apiClient.get<CaptchaChallenge>('/admin/auth/captcha');
}

export interface ChangePasswordBody {
  currentPassword: string;
  newPassword: string;
}

export async function changePassword(body: ChangePasswordBody): Promise<void> {
  await apiClient.post<void>('/admin/auth/change-password', body);
}
